var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFile = function SvgFile(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.714 0A1.714 1.714 0 0 0 0 1.714v8.572A1.714 1.714 0 0 0 1.714 12h6.857a1.714 1.714 0 0 0 1.715-1.714V4.035a.86.86 0 0 0-.251-.606L6.857.25A.86.86 0 0 0 6.251 0zM6 .857V3.43a.857.857 0 0 0 .857.857H9.43z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFile);
export { ForwardRef as ReactComponent };